import { initializeApp } from "firebase/app";
import { FirebaseAppProvider } from "reactfire";
import ReduxProvider from "./navigation/redux";
import Router from "./navigation/router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const firebaseConfig = {
  apiKey: "AIzaSyDgTUSu74Dw8tDnXtZ8kNQ7inq5DzJ-V_c",
  authDomain: "preferred-title.firebaseapp.com",
  projectId: "preferred-title",
  storageBucket: "preferred-title.appspot.com",
  messagingSenderId: "686042085011",
  appId: "1:686042085011:web:10adb0ad1f98778ac6bf66",
  measurementId: "G-MQQ1YZGYSS",
};

initializeApp(firebaseConfig);

function App() {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <ReduxProvider>
        <Router />
        <ToastContainer />
      </ReduxProvider>
    </FirebaseAppProvider>
  );
}

export default App;
